'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _StaticArticle = require('../sections/StaticArticle');

var _StaticArticle2 = _interopRequireDefault(_StaticArticle);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

require('../../styles/templates/blog.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Article = function Article() {
  (0, _classCallCheck3.default)(this, Article);

  var sections = window.shopifySections || new _shopifySectionsManager2.default();
  sections.register('static-article', function (section) {
    return new _StaticArticle2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = Article;


new Article();